var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price"},[(_vm.hasVariations)?_c('span',{staticClass:"js-price-is-much"},[_vm._v(_vm._s(_vm.priceIsMuchText))]):_vm._e(),_vm._v("\n    "+_vm._s(_vm.mainPriceWithoutTax)+" "+_vm._s(_vm.currency)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }